import type { NextPage } from "next";
import type { SVGProps } from "react";

import { ColorMain } from "@/types/styles/designSystemEnum";

interface Props extends SVGProps<SVGSVGElement> {
  stroke?: string;
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LessOrEqualIcon: NextPage<Props> = ({
  fill = "currentColor",
  stroke = ColorMain.BLACK_MAIN,
  from,
  to,
  gradientId = "LessOrEqualIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M12 3V5.19378L6.54264 6.80256L12 8.42962V10.66L4 8.15539V5.5777L12 3ZM4 10.8245H12V13H4V10.8245Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};

export default LessOrEqualIcon;
